import React, { useState, useEffect, useCallback } from 'react';
import { Cart, Payload } from '../@types/Data';
import { Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@material-ui/core';
import { deleteItemFromCart, getCart, getPaymentPage, getPaymentToken } from '../utils/RequestMaker';
import '../styles/style.css';
import Moment from 'moment';
import 'moment/locale/es'
import validator from 'validator';
import { RouteComponentProps, useHistory } from 'react-router-dom';

interface CartParams {
    id_bu: string;
}

type CartProps = RouteComponentProps<CartParams>;

export const CartPage: React.FC<CartProps> = (props: CartProps) => {
    const id_bu = props.match.params.id_bu;
    const uuid = sessionStorage.getItem('idCompra');
    const history = useHistory();
    const urlBaseImage = 'https://res.cloudinary.com/marketingpyme/image/upload/w_127,h_95,c_fill/servicios/';
    
    const [cart, setCart] = useState<Cart[]>();
    const [nombre, setNombre] = useState<string>("");
    const [telefono, setTelefono] = useState<string>("");
    const [email, setEmail] = useState<string>("");
    const [dataIncorrecto, setDataIncorrecto] = useState<boolean>(false);
    const [emailIncorrecto, setEmailIncorrecto] = useState<boolean>(false);
    const [telefonoIncorrecto, setTelefonoIncorrecto] = useState<boolean>(false);
    const [openDataProblemPopup, setOpenDataProblemPopup] = useState<boolean>(false);
    const [totalAmount, setTotalAmount] = useState<number>(0);
    
    let signature= ""; // Se manda vacío para rellenarlo en el back
    let additional_info = "";
    let customer_ext_id = "";
    let service_uuid = ""; // Se manda vacío para rellenarlo en el back
    let url_post = "https://api.marketingpyme.com/api/payment/result"; // original Jesús
    let url_ok_base = "https://ticket.crea-ticket.com/";
    let url_ko = "https://widget.marketingpyme.com/payment/error";

    useEffect((() => {
        if(!cart) {
            Moment.locale('es');
            if(uuid) {
                getCart(uuid).then((res) => {
                    setCart(res);
                });
            }
        } else {
            let total = 0;
            cart.forEach((item) => {
                const payload: Payload = JSON.parse(item.Json);
                total += payload.total;
            });
            setTotalAmount(total);
        }

    }) , [uuid, cart]);

    const nombreChangeHandler = useCallback((event) => {
        setNombre(event.target.value);
    }, []);

    const telefonoChangeHandler = useCallback((event) => {
        setTelefono(event.target.value);
    }, []);

    const emailChangeHandler = useCallback((event) => {
        setEmail(event.target.value);
    }, []);

    const closeClickDataProblemHandler = () => {
        setOpenDataProblemPopup(false);
    };

    const deleteCartItem = (event: any) => {
        if(uuid && cart) {
            const index = event.currentTarget.value;
            const payload = JSON.parse(cart[index].Json);
            const stretch_id = payload.stretch_id;
            const ticketNumber = payload.numero;

            deleteItemFromCart(uuid, stretch_id, ticketNumber).then((res) => {
                if(res === 414) {
                    history.push(`/error/${"El número de ticket no existe."}/${id_bu}`);
                } else if(res > 0) {
                    getCart(uuid).then((res) => {
                        setCart(res);
                    });
                } else {
                    history.push(`/error/${"Hemos obtenido un error inesperado."}/${id_bu}`);
                }
            });
        }
    }

    const sendPayment = () => {
        if(nombre !== "" && telefono !== "" && email !== "") {
            if(!validator.isMobilePhone(telefono) || !validator.isEmail(email)) {
                setDataIncorrecto(true);
                if(!validator.isEmail(email)) setEmailIncorrecto(true);
                if(!validator.isMobilePhone(telefono)) setTelefonoIncorrecto(true);
            } else {
                if(cart) {
                    let numeros: string[] = [];
                    let nombreTrayecto = "";
                    cart.forEach((item) => {
                        numeros.push(JSON.parse(item.Json).numero);
                        nombreTrayecto += JSON.parse(item.Json).stretchName + " - ";
                    });
                    const client = 'Zostera';
                    let url_ok = `${url_ok_base}?client=${client}&`;
                    numeros.forEach((numero) => {
                        url_ok += `numeros=${numero}&`; 
                    });
                    url_ok = url_ok.substr(0, url_ok.length - 1);
                    nombreTrayecto = nombreTrayecto.substr(0, nombreTrayecto.length - 2);
                    const description = nombre + " - " + telefono + " - " + email;
                    
                    additional_info = JSON.stringify({
                        url: url_ok,
                        uuid: sessionStorage.getItem('idCompra'),
                        stretchName: nombreTrayecto,
                        stretchDescription: "Los tickets reservados para esos trayectos se encuentran pulsando el botón de los tickets.",
                        tokenticket: sessionStorage.getItem('tokenTicket'),
                        description: description,
                        nombre: nombre,
                        email: email,
                        telefono: telefono
                    });
                    getPaymentToken(signature, totalAmount*100, customer_ext_id, additional_info, service_uuid, url_post, description, url_ok, url_ko).then((res) => {
                        getPaymentPage(res.token).then((result) => {
                            // Redirecciona a la url
                            window.location.href = result;
                        });
                    });
                }
            }
        } else {
            setOpenDataProblemPopup(true);
        }
    }

    return(
        <div className="page-wrapper animated fadeIn">
            <header className="book-embed-nav with-padding respond-print-hide">
                <div className="ben-right">
                    <ul className="ben-left">
                        <li className="ben-flyout-wrap">
                            <button className="ben-item ben-secure-button fh-green" type="button"
                                    aria-expanded="false">
                                <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false"
                                     id="icon-svg-lock" className="icon-svg-lock" width="11" height="14"
                                     viewBox="0 0 11.02 14" ng-svg="icon-svg-lock">
                                    <path d="M7.66,3.88a2.15,2.15,0,0,0-4.3,0v2h4.3Z" style={{fill: 'none'}}></path>
                                    <path
                                        d="M9.39,5.85v-2a3.88,3.88,0,0,0-7.76,0v2A1.72,1.72,0,0,0,0,7.56v4.73A1.72,1.72,0,0,0,1.71,14h7.6A1.72,1.72,0,0,0,11,12.29V7.56A1.71,1.71,0,0,0,9.39,5.85Zm-6-2a2.15,2.15,0,0,1,4.3,0v2H3.36Z"></path>
                                </svg>
                                Pago Seguro
                            </button>

                        </li>

                        <li className="ben-flyout-wrap">

                            <div>
                                <a className="ben-item ben-cart-button fade-in-up" type="button"
                                        aria-expanded="false" href={`/cart/${id_bu}`}>
                                    <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" id="icon-cart"
                                         className="icon-cart" width="27" height="23" viewBox="0 0 27 23" style={{fill: 'white'}}
                                    >
                                        <path
                                            d="M24.47,16.68H7.12l-3.74-14H.08V.21H5.42l3.74,14H22.31l1.58-8.48H11.25V3.22H26.92Z"></path>
                                        <path d="M23,20.59a2.2,2.2,0,1,0-2.2,2.2A2.19,2.19,0,0,0,23,20.59Z"></path>
                                        <path d="M12.19,20.59A2.2,2.2,0,1,0,10,22.79,2.19,2.19,0,0,0,12.19,20.59Z"></path>
                                    </svg>
                                    <span className="respond-handhelds-hide">Carrito</span>
                                    <span className="respond-desktop-hide"></span>
                                </a>
                            </div>

                        </li>
                    </ul>
                    <div className="ben-flyout-wrap" ng-if="lightframe.isLightframe() || backUrl">
                        <button className="ben-item ben-close-button test-toggle-leave-flyout-action" type="button"
                                aria-expanded="false">
                            <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" id="icon-x"
                                 className="icon-x" width="14" height="14" viewBox="0 0 14 14" >
                                <polygon
                                    points="14 1.75 12.25 0 7 5.25 1.75 0 0 1.75 5.25 7 0 12.25 1.75 14 7 8.75 12.25 14 14 12.25 8.75 7 14 1.75"></polygon>
                            </svg>
                            <span className="visually-hidden">Cerrar</span>
                        </button>

                    </div>
                </div>

            </header>
            <nav className="flow-breadcrumbs test-breadcrumbs-indicator" aria-label="Breadcrumb">
                <ol>
                    <li className="test-flow-node-breadcrumb" aria-label="Home"
                        title="Home">
                        <a href={`/${id_bu}`}>
                            <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" id="icon-home"
                                 className="icon-home" width="13" height="13" viewBox="0 0 13 13"
                            >
                                <path
                                    d="M5.63.28l-5,3.54A1.61,1.61,0,0,0,0,5.15v6.52A1.32,1.32,0,0,0,1.34,13H4.46V9.66a2.06,2.06,0,0,1,4.12,0h0V13h3.08A1.31,1.31,0,0,0,13,11.72V5.15a1.66,1.66,0,0,0-.68-1.33L7.41.28A1.57,1.57,0,0,0,5.63.28Z"></path>
                            </svg>
                        </a>
                        <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" id="icon-arrow-rounded"
                             className="icon-arrow-rounded" width="12" height="10" viewBox="0 0 12 10"
                        >
                            <path
                                d="M11.72,4.25,7.77.3A1,1,0,0,0,6.36,1.63l0,0L8.73,4H1A1,1,0,1,0,1,5.93H8.71L6.4,8.25a1,1,0,0,0,0,1.37,1,1,0,0,0,1.34,0l4-3.95A1,1,0,0,0,12,5v0A1,1,0,0,0,11.72,4.25Z"></path>
                        </svg>
                    </li>
                    <li className="breadcrumb-current test-current-breadcrumb" aria-current="location">
                        Carrito
                    </li>
                </ol>
            </nav>
            <section className="page-header tour-two tour-list destinations-details">
                <div className="container">
                    <div className="row">
                        <div className="col-md-8">
                            <h3 className="destinations-details__title">Finalizar compra</h3>
                        </div>
                        <div className="col-md-4">

                            <div className="flow-header-button-wrap">
                                <a className="flow-header-button flow-activities-button test-keep-shopping-link respond-print-hide"

                                   href={`/${id_bu}`}>
                                    <span className="flow-activities-button-icon">
                                    <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" id="icon-home" className="icon-home" width="13" height="13"
                                        viewBox="0 0 13 13" ng-svg="icon-home">
                                    <path
                                        d="M5.63.28l-5,3.54A1.61,1.61,0,0,0,0,5.15v6.52A1.32,1.32,0,0,0,1.34,13H4.46V9.66a2.06,2.06,0,0,1,4.12,0h0V13h3.08A1.31,1.31,0,0,0,13,11.72V5.15a1.66,1.66,0,0,0-.68-1.33L7.41.28A1.57,1.57,0,0,0,5.63.28Z"></path>
                                    </svg>
                                    </span>
                                                                        <span className="flow-activities-button-text">
                                    Seguir Comprando
                                    </span>
                                </a>
                            </div>
                        </div>
                    </div>

                    <div className="sidebar__single">
                        <div style={{ padding: "0px 25px" }}>
                            {
                                // Incluir los items del carrito
                                cart && cart.map((item) => {
                                    const payload: Payload = JSON.parse(item.Json);
                                    const image = urlBaseImage + payload.operationLine_id + "-" + payload.stretch_id + ".jpg";
                                    return(
                                        <>
                                            <div className="row destinations-details__content sidebar__item">
                                                <div className="col-sm-8">
                                                    <div className="row">
                                                        <div className="col-sm-3"><img src={ image } alt = { payload.stretchName } className="img-fluid" /></div>
                                                        <div className="col-sm-9">  <h4 className="tramoSeleccionado">{ payload.stretchName }</h4>
                                                            <p>{ Moment(payload.datebook).format('dddd, D MMMM YYYY [a las] HH:mm') }</p>
                                                            <div><button className="btn btn-underline" onClick={deleteCartItem} value={cart.indexOf(item)}>Eliminar</button></div>
                                                        </div>
                                                    </div>
                                                  </div>

                                                <div className="col-sm-2 col-6">
                                                    <p>
                                                        {
                                                            payload.lines.map((line) => {
                                                                return(
                                                                    <div>
                                                                        { line.quantity !== 0 && line.passengerCategoryName + ": " + line.quantity }
                                                                    </div>
                                                                )
                                                            })
                                                        }
                                                    </p>
                                                </div>

                                                <div className="col-sm-2 col-6 text-right">
                                                    <p>
                                                        { payload.total.toFixed(2) } €
                                                    </p>
                                                </div>
                                            </div>
                                        </>
                                    )
                                })
                            }
                            <div>
                                <div className="book-form-totals book-form-totals2 has-secure-badge has-totals">
                                    <div className="table valign-middle full-width">
                                        <div className="tr">
                                            <div className="td">
                                                <p className="secure-badge respond-handhelds-hide">
                                                    <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true"
                                                         focusable="false" id="icon-svg-lock" className="icon-svg-lock"
                                                         width="11" height="14" viewBox="0 0 11.02 14"
                                                         ng-svg="icon-svg-lock">
                                                        <path d="M7.66,3.88a2.15,2.15,0,0,0-4.3,0v2h4.3Z"
                                                              style={{fill: 'none'}}></path>
                                                        <path
                                                            d="M9.39,5.85v-2a3.88,3.88,0,0,0-7.76,0v2A1.72,1.72,0,0,0,0,7.56v4.73A1.72,1.72,0,0,0,1.71,14h7.6A1.72,1.72,0,0,0,11,12.29V7.56A1.71,1.71,0,0,0,9.39,5.85Zm-6-2a2.15,2.15,0,0,1,4.3,0v2H3.36Z"></path>
                                                    </svg>
                                                     Asegurado por encriptaci&oacute;n de 2048-bit
                                                </p>
                                            </div>
                                            <div className="td"><div className="text-right">Total: { totalAmount.toFixed(2)} €</div> </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <h4 className="tramoSeleccionado">Datos de la reserva</h4>
                            <div className="row centrado">
                                <div className="col-sm-8">

                                    <div className="formularioReserva">
                                        <div className="input-group mb-3">
                                            <input type="text" className="form-control" placeholder="Nombre Completo" aria-label="Nombre Completo" aria-describedby="addon-wrapping" onChange={nombreChangeHandler} required />
                                        </div>

                                        <div className="input-group mb-3">
                                            <input type="text" className="form-control" placeholder="N&uacute;mero de tel&eacute;fono" aria-label="N&uacute;mero de tel&eacute;fono" aria-describedby="addon-wrapping" onChange={telefonoChangeHandler} required />
                                        </div>

                                        <div className="input-group mb-3">
                                            <input type="text" className="form-control" placeholder="Direcci&oacute;n de e-mail" aria-label="Direcci&oacute;n de e-mail" aria-describedby="addon-wrapping" onChange={emailChangeHandler} required />
                                        </div>

                                    </div>
                                </div>
                                <div className="col-sm-4 centrado">
                                    <button type="submit" className="btn btn-huge sobredimensionado btn-block btn-large btn-primary" onClick={sendPayment} >Reservar</button>
                                </div>
                            </div>


                        </div>
                    </div>



                    <div className="row">

                        <Dialog onClose={() => {
                            setDataIncorrecto(false);
                            setTelefonoIncorrecto(false);
                            setEmailIncorrecto(false);
                        }} aria-labelledby="customized-dialog-title" open={dataIncorrecto} >
                            <DialogTitle id="customized-dialog-title">{telefonoIncorrecto && "Teléfono"}{telefonoIncorrecto && emailIncorrecto && " y "}{emailIncorrecto && "Email"} Incorrecto</DialogTitle>
                            <DialogContent dividers>
                                <Typography gutterBottom>
                                    <b>El {telefonoIncorrecto && "Teléfono"}{telefonoIncorrecto && emailIncorrecto && " y "}{emailIncorrecto && "Email"} introducido no tiene el formato correcto.</b>
                                </Typography>
                            </DialogContent>
                            <DialogActions>
                                <button type="button" className="btn btn-primary" onClick={() => {
                                    setDataIncorrecto(false);
                                    setTelefonoIncorrecto(false);
                                    setEmailIncorrecto(false);
                                }} >Cerrar</button>
                            </DialogActions>
                        </Dialog>

                        <Dialog onClose={closeClickDataProblemHandler} aria-labelledby="customized-dialog-title" open={openDataProblemPopup} >
                            <DialogTitle id="customized-dialog-title">Introduzca los campos necesarios.</DialogTitle>
                            <DialogContent dividers>
                                <Typography gutterBottom>
                                    <b>No ha introducido todos los campos necesarios para continuar.</b>
                                </Typography>
                            </DialogContent>
                            <DialogActions>
                                <button type="button" className="btn btn-primary" onClick={closeClickDataProblemHandler} >Cerrar</button>
                            </DialogActions>
                        </Dialog>

                    </div>

                </div>
            </section>
            <footer className="book-embed-footer">
                <div className="book-embed-footer-left">
                    <div>
                        <div className="ben-translate-toggle respond-print-hide">
                            <button className="ben-item ben-translate-button capitalize" type="button"
                                    aria-describedby="translate-btn-describe"
                                    aria-expanded="false">
                                <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" id="icon-globe"
                                     className="icon-globe" width="14" height="14" viewBox="0 0 14 14"
                                     ng-svg="icon-globe">
                                    <path
                                        d="M14 7a7 7 0 11-7-7 7 7 0 017 7zM4 7.51v1h2.41c.41 0 .59.19.59.6v1.81c0 .91.14.74-.67 1.34l-.76.58a6.09 6.09 0 005.3-1.24l-.17-.19-1.48-1.48A.65.65 0 019 9.41V7.62c0-.11-.46 0-.46-.12h-.86c-.41 0-.59-.19-.59-.59V5.66A.67.67 0 017.46 5c1.07-.67 2.54-1.35 3.62-2l.24-.15-.83-.72-2.62 1.72a.53.53 0 01-.81-.08L4.88 1.58c-.1-.09-.17-.13-.3-.07a6.13 6.13 0 00-2.64 2.27 2 2 0 00-.12.22h3.56c.44 0 .62.18.62.62v2.29c0 .4-.18.58-.58.59zm1-1V5H1.55a.24.24 0 00-.27.2 6 6 0 003 7.16.21.21 0 00.28 0 9.64 9.64 0 011-.71.87.87 0 00.44-.97 11.76 11.76 0 010-1.19H3.62c-.44 0-.62-.17-.62-.61V7.09c0-.4.18-.58.58-.59zm6.58 4.36a5.89 5.89 0 00.36-7.22c-1.11.7-2.64 1.4-3.76 2.1a.2.2 0 00-.08.12v.63h1.33a.51.51 0 01.57.58v2.05a.35.35 0 00.07.23zm-4-8l1.93-1.31a6 6 0 00-3.64-.45c.57.58 1.13 1.15 1.72 1.73z"></path>
                                </svg>
                                Espa&ntilde;ol (ES)
                            </button>

                        </div>
                    </div>

                </div>
                <div className="book-embed-footer-right">
                    <img src="https://res.cloudinary.com/marketingpyme/image/upload/w_160,h_45,c_fill/servicios/logotipo-civitrip.png" className="img-fluid __web-inspector-hide-shortcut__" alt="CIVITRIP" />
                </div>
            </footer>
        </div>
    );
}
